import type {Components, CSSObject, Theme} from '@mui/material/styles';
import {COLORS} from '../../colors-ts';

const standardAlertStyle = (backgroundColor: string, color: string): CSSObject => ({
    backgroundColor,
    color,
    '& .MuiAlert-icon': {
        color,
    },
});

const outlinedAlertStyle = (color: string, accentColor: string): CSSObject => ({
    color,
    borderColor: accentColor,
    '& .MuiAlert-icon': {
        color: accentColor,
    },
});

export const alertOverrides: Components<Theme>['MuiAlert'] = {
    styleOverrides: {
        icon: {
            alignSelf: 'center',
        },
        standardSuccess: standardAlertStyle(COLORS.success[100], COLORS.success[900]),
        standardInfo: standardAlertStyle(COLORS.mithraBlue[100], COLORS.mithraBlue[900]),
        standardWarning: standardAlertStyle(COLORS.warning[100], COLORS.warning[900]),
        standardError: standardAlertStyle(COLORS.error[100], COLORS.error[900]),
        outlinedSuccess: outlinedAlertStyle(COLORS.success[900], COLORS.success[500]),
        outlinedInfo: outlinedAlertStyle(COLORS.mithraBlue[900], COLORS.mithraBlue[500]),
        outlinedWarning: outlinedAlertStyle(COLORS.warning[900], COLORS.warning[500]),
        outlinedError: outlinedAlertStyle(COLORS.error[900], COLORS.error[500]),
    },
};
